exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-main{padding-top:50px;margin-left:180px;transform:translateZ(0)}@media screen and (max-width:768px){.app-main{margin-left:0}}.app-content{padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea029922","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/AppMain.vue
// module id = 40
// module chunks = 4